import { Component } from '@angular/core';

import { ProjectFile } from '@custom-types/file';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { GlobalFunctionService } from '@providers/global-function/global-function.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';

@Component({
  selector: 'app-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.less']
})
export class FilesComponent {
  files: any;
  filteredFiles: any;
  fileTypeCategories = {
    doc: 'Documents génériques',
    note: 'Notes',
    plan: 'Plans',
    picture: 'Photos et images',
    invoice: 'Factures',
    planning: 'Planning',
    contract: 'Contrats',
    quote: 'Devis',
    delivery_note: 'Bons de livraisons',
    order_form: 'Bons de commande',
    inbound_delivery_note: 'Bons de livraisons entrée',
    outgoing_delivery_note: 'Bons de livraison sortie'
  };
  currentProject: any;
  inited: boolean = false;

  constructor(
    private globalDataService: GlobalDataService,
    private globalFunctionService: GlobalFunctionService,
    private requestService: RequestService,
    private requestV2Service: RequestV2Service
  ) {
    this.files = {};
    this.filteredFiles = {};

    this.globalDataService.getCurrentProject().subscribe(async (project: any) => {
      if (!project || this.currentProject) {
        return;
      }
      this.currentProject = project;
      if (!this.inited) {
        this.inited = true;
        const projectFilesResult = await this.requestV2Service.getProjectFiles(project.id, true);

        projectFilesResult.items.forEach((file) => {
          const fileCategory = this.fileTypeCategories[file.type];

          if (!this.files[fileCategory]) {
            this.files[fileCategory] = [];
          }
          this.files[fileCategory].push(file);
        });

        this.filteredFiles = { ...this.files };
      }
    });
  }

  private filter(text: string) {
    if (!text || text.length <= 0) {
      this.filteredFiles = { ...this.files };
      return;
    }

    this.filteredFiles = {};

    Object.keys(this.files).forEach((key) => {
      this.files[key].forEach((file: ProjectFile) => {
        if (file.original_filename.toLowerCase().includes(text.toLowerCase())) {
          if (!this.filteredFiles[key]) {
            this.filteredFiles[key] = [];
          }

          this.filteredFiles[key].push(text);
        }
      });
    });
  }

  isEmpty(): boolean {
    return (
      !this.filteredFiles ||
      (Object.entries(this.filteredFiles).length === 0 && this.filteredFiles.constructor === Object)
    );
  }

  searchEvent(event) {
    this.filter(event.target.value);
  }

  private download(file: any) {
    this.requestV2Service.downloadFile(file.id_file)
      .then((data) => {
        this.globalFunctionService.downloadFile(data);
      });
  }
}
